import React from 'react';
import { UserPanel as UiUserPanel } from '@srm/ui/shell/UserMenu';
import { useTypedSelector } from '@hooks/useTypedSelector';
import UserAvatar from '@molecules/UserAvatar/UserAvatar';
import { AVATAR_SIZES } from '@srm/ui/avatar';

interface IUserPanelProps {
    onOrgChange: () => void;
    /** Открыть редактор аватара (быстрый доступ из меню пользователя). */
    onEditAvatar: () => void;
    /** Закрыть онбординг-хинт крестиком (и не показывать следующий шаг). */
    onDismissHint: () => void;
    /** Показывать онбординг-хинт на аватаре (второй шаг). */
    avatarHintOpen: boolean;
}

/** Карточка пользователя меню профиля (`@srm/ui/shell/UserMenu`) — данные из стора Front. */
const UserPanel: React.FC<IUserPanelProps> = ({ onOrgChange, onEditAvatar, onDismissHint, avatarHintOpen }) => {
    const user = useTypedSelector((state) => state.auth.user);
    const avatarVersion = useTypedSelector((state) => state.userAvatar.version);
    // ?v= для своего аватара: основной источник — photoVersion из auth-стейта (immutable-кэш,
    // переживает reload). Локальный bump перебивает его лишь как немедленный cache-bust сразу
    // после смены своего фото; после reload bump=0 и снова используется photoVersion.
    const effectiveAvatarVersion = avatarVersion || user.photoVersion;
    const canViewDepartment = user.canUserDepartmentView && !!user.departmentId;

    return (
        <UiUserPanel
            user={{
                fullName: `${user.firstName}` + (user.middleName ? ` ${user.middleName}` : '') + ` ${user.lastName}`,
                position: user.position,
                department: canViewDepartment ? (user.department ?? '') : undefined,
                departmentInn: canViewDepartment ? user.subdivisionInn : undefined,
                subdivision: user.subdivision,
                phone: user.phone,
                email: user.email,
            }}
            avatar={
                <UserAvatar
                    userKey={String(user.id)}
                    name={user.fullName}
                    hasImage={user.hasImage}
                    version={effectiveAvatarVersion}
                    size={AVATAR_SIZES.xl}
                />
            }
            onEditAvatar={onEditAvatar}
            onChangeDepartment={canViewDepartment && user.canUserDepartmentEdit ? onOrgChange : undefined}
            avatarHintOpen={avatarHintOpen}
            onDismissAvatarHint={onDismissHint}
        />
    );
};

export default UserPanel;
